<template>
  <div
    class="main"
    v-if="info.hasOwnProperty('id')"
    v-wechat-title="region.re_name+('-皖云游-'+info.type_name)+'-'+ info.DicName"
  >
    <TravelTop :info="info" :region="region" />

    <TravelAbout
      v-if="simages.hasOwnProperty(1)"
      :simages="simages[1]"
      :summary="info.Summary"
    />
    <TravelAudio :audios="audios" />
    <Basic :info="info" />
    <!-- 天气预报 -->
		<WeatherForecast :list="WeatherForecastList" />
    <TravelMap :info="info" :center="center" :region="region" />
    <!--平面导览-->
    <TravelImage v-if="simages.hasOwnProperty(2)" :simages="simages[2]" />

    <TravelVideo :videos="videos" />

    <TravelDetail
      name="历史沿革"
      enname="Historical evolution"
      :detail="info.History"
    />
    <TravelDetail
      name="经济发展"
      enname="Economic development"
      :detail="info.Economic"
    />
    <TravelDetail
      name="文旅规划"
      enname="Development planning"
      :detail="info.Development"
    />
    <TravelDetail
      name="节庆活动"
      enname="Festival activities"
      :detail="info.Activities"
    />
    <TravelDetail
      name="游玩路线"
      enname="Tourist route"
      :detail="info.TouristRoute"
    />

    <!--节庆活动-->
    <TravelScenicmianspots :scenicmianspots="scenicmianspots" />
    <TravelDetail
      name="旅游景区"
      enname="Tourist attraction"
      :detail="info.TouristAttraction"
    />
    <TravelDetail
      name="旅游住宿"
      enname="Tourist accommodation"
      :detail="info.Hotes"
    />
    <TravelDetail
      name="餐饮农家乐"
      enname="Farm Tourism"
      :detail="info.Restaurants"
    />
    <TravelDetail
      name="特色美食"
      enname="Delicious food"
      :detail="info.Foods"
    />
    <TravelDetail
      name="特产商品"
      enname="Tourist commodities"
      :detail="info.Commodities"
    />
    <TravelLocalcelebrity
      name="名人文化"
      enname="Celebrity culture"
      :list="localcelebrities"
    />
    <TravelDetail
      name="民俗非遗"
      enname="Folk heritage"
      :detail="info.FolkHeritage"
    />
    <TravelDetail
      name="传说掌故"
      enname="Legend story"
      :detail="info.LegendStory"
    />
    <TravelDetail
      v-if="traffic"
      name="交通指引"
      enname="Traffic guide"
      :detail="traffic.Detail"
    />

    <Scolllist :scoltoplist="scoltoplist"></Scolllist>
    <!-- 相关词条 -->
    <TravelRelevant :dicrelevants="dicrelevants" />
    <TravelPingjia :list="pingjia_list" :total="pingjia_total" :info="info" />

    <TravelFooter :info="info" :region="region" />
  </div>
</template>

<script>
import { travelInfo,areaweather } from "@/api/travel";
import TravelDetail from "@/components/travel/detail";
import TravelRelevant from "@/components/travel/relevant";
import TravelScenicmianspots from "@/components/travel/scenicmianspots";
import TravelVideo from "@/components/travel/video";
import TravelImage from "@/components/travel/image";
import TravelMap from "@/components/travel/map";
import TravelAbout from "@/components/travel/about";
import TravelTop from "@/components/travel/top";
import TravelFooter from "@/components/travel/footer";
import TravelAudio from "@/components/travel/audio";
import TravelLocalcelebrity from "@/components/travel/localcelebrity";
import TravelPingjia from "@/components/travel/pingjia";
import Scolllist from "@/components/Scolllist";
import Basic from "@/components/travel/basic";
import WeatherForecast from '@/components/travel/weatherForecast'
export default {
  data() {
    return {
      info: this.$store.state.acc,
      user: this.$store.state.user,
      center: { lng: 0, lat: 0 },
      info: {},
      region: {},
      simages: {},
      scenicmianspots: [],
      traffic: {},
      dicrelevants: [],
      videos: [],
      audios: [],
      localcelebrities: [],
      pingjia_list: [],
      pingjia_total: 0,
      WeatherForecastList: [],
      scoltoplist: ['简介','基本资料','导航','视频','经济发展','节庆活动','游玩路线','乡村旅游','旅游景区','旅游住宿','餐饮农家乐','特色美食','特产商品','名人文化','名俗非遗','传说掌故','交通指引','相关词条']
    };
  },
  components: {
    TravelMap,
    TravelDetail,
    TravelRelevant,
    TravelScenicmianspots,
    TravelVideo,
    TravelImage,
    TravelAbout,
    TravelTop,
    TravelFooter,
    TravelAudio,
    TravelLocalcelebrity,
    TravelPingjia,
    Scolllist,
    Basic,
    WeatherForecast
  },
  created(e) {
    this.getInfo();
  },
  mounted() {
  },
  methods: {
    //天气预报
		weatherForecast(){
			areaweather({
				Latitude: this.info.Latitude,
				Longitude: this.info.Longitude,
			}).then(res=>{
				// console.log(res);
				res.weadata.forEach(v=>{
					this.WeatherForecastList.push(v)
				})
			})
		},
    getInfo() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: false,
        loadingType: "spinner",
        duration: 10000,
      });
      travelInfo({ type: "Town", id: this.$route.params.id }).then((res) => {
        // console.log(res);
        this.$toast.clear();
        this.info = res.info;
        this.region = res.Region;
        this.$store.commit("SET_RGION", this.region);
        this.simages = res.Images;
        this.traffic = res.traffic;
        this.audios = res.audios;
        this.videos = res.videos;
        for (let i in res.scenicmianspots) {
          res.scenicmianspots[i]["text"] = res.scenicmianspots[i]["SpotName"];
        }
        this.scenicmianspots = res.scenicmianspots;
        this.localcelebrities = res.localcelebrities;
        this.dicrelevants = res.dicrelevants;
        this.pingjia_list = res.pingjia_list;
        this.pingjia_total = res.pingjia_total;
        this.weatherForecast()
      });
    },
  },
};
</script>
<style>
body {
  height: auto;
}
</style>